import $ from 'jquery';
import 'slick-carousel';

const initTabs = () =>   {

  let tabTriggers = document.querySelectorAll('.formTrigger');
  let tabContents = document.querySelectorAll('.form-content');

  Array.prototype.forEach.call(tabTriggers, (trigger) => {

    trigger.addEventListener('click', (e) => {

      document.querySelector('.page-link--active').classList.remove('page-link--active');
      document.querySelector('.form-content--active').classList.remove('form-content--active');

      e.preventDefault();

      let clickedFormnumber = trigger.attributes.formnumber.value;

      trigger.classList.add('page-link--active');


      Array.prototype.forEach.call(tabContents, (tab) => {

        let formnumber = tab.attributes.formnumber.value;

        if (clickedFormnumber === formnumber)
          tab.classList.add('form-content--active');
      })

    });

  });

}


function EnquiryTabs () {
  initTabs();
}

export default EnquiryTabs;